import { render, staticRenderFns } from "./daildsp.vue?vue&type=template&id=6918a456&scoped=true&"
import script from "./daildsp.vue?vue&type=script&lang=js&"
export * from "./daildsp.vue?vue&type=script&lang=js&"
import style0 from "./daildsp.vue?vue&type=style&index=0&id=6918a456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918a456",
  null
  
)

export default component.exports